import _ from 'lodash';
import BaseCtrl from 'edge/platform/base/BaseCtrl';
import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';
import 'gw-portals-util-angular';
import DateUtil from 'gw-portals-util-js/DateUtil';
import LocalDateUtil from 'gw-portals-util-js/LocalDateUtil';

var fn = function fn($translate, $q, $filter, lobConfig, $scope, $state, $stateParams, $window, ModalService, AccountService, SubmissionService, ProductService, UserService, OrganizationService, NewAccountService, defaultLocaleDetails, ViewModelService, UserInfoService, GPA_PC_ENTRY_POINT, LocaleService, PolicyService) {
    var lobMap = {
        'PersonalAuto': 'pa',
        'Homeowners': 'ho',
        'HOPHomeowners': 'ho',
        'CommercialProperty': 'cp',
        'BusinessOwners': 'bop',
        'WorkersComp': 'wc'
    };
    var ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {
        var applicationFeatures = ApplicationFeatures.getAllFeatures();
        $scope.accountTypes = applicationFeatures.accountTypes;
        $scope.gatewayQuote = applicationFeatures.gatewayquoteandbind === 'true';
        // console.log("test-->"+angular.element('#msfEntityType').on('.gw-required-asterisk').attr('class'))
        $scope.notRequired = false;
        $scope.error_exist = false;
        angular.element(".msfEntityType").find(".gw-required-asterisk").css("display", "none");
        //$scope.today = DateUtil.currentDateAtMidnight();
        //$scope.tomorrow = nextDateAtMidnight();
        PolicyService.getCurrentDate().then(function (res) {
            var dateToday = LocalDateUtil.today();
            var today = res.match(/(\d+)/g);
            var nextDay = new Date(today[0], today[1] - 1, parseInt(today[2]) + 1, today[3], today[4], today[5]);
            //nextDay.setDate(today.getDate()+1);
            console.log("next day-->");console.log(nextDay);
            dateToday.day = nextDay.getDate();
            dateToday.month = nextDay.getMonth();
            dateToday.year = nextDay.getFullYear();
            $scope.tomorrow = dateToday;
        });
        //console.log($scope.tomorrow);
        $scope.defaultStateCode = '';
        //$scope.hideFields = ['AddressLine3'];
        $scope._availableProducts = [];
        $scope.isAgent = UserInfoService.isAgent();
        $scope.phoneMask = LocaleService.getRegionSamplePhoneNumber().replace(/[0-8]/g, '9') + ' x ?9?9?9?9';
        $scope.phoneMaskWithoutExt = LocaleService.getRegionSamplePhoneNumber().replace(/[0-8]/g, '9');
        $scope.selectedOrganizationSubmissionVM = {
            aspects: {
                required: true,
                visible: true,
                get validationMessages() {
                    return [$filter('translate')('gateway.views.new-quote.errors.This is a required field')];
                },
                get valid() {
                    return $scope.selectedOrganizationSubmissionVM.value;
                }
            },
            value: ''
        };

        //Function to default to tomorrow effective date_MSF

        function nextDateAtMidnight() {
            $scope.tomorrow = PolicyService.getCurrentDate().then(function (res) {
                var dateToday = LocalDateUtil.today();
                var today = res.match(/(\d+)/g);
                var nextDay = new Date(today[0], today[1] - 1, parseInt(today[2]) + 1, today[3], today[4], today[5]);
                //nextDay.setDate(today.getDate()+1);
                //console.log("next day-->");console.log(nextDay);
                dateToday.day = nextDay.getDate();
                dateToday.month = nextDay.getMonth();
                dateToday.year = nextDay.getFullYear();
                return dateToday;
            });
            /*var dateToday=LocalDateUtil.today();
            var today = new Date();
            var nextDay = new Date(today);
            nextDay.setDate(today.getDate()+1);
            dateToday.day=nextDay.getDate();
            dateToday.month=nextDay.getMonth();
            dateToday.year=nextDay.getFullYear();
            return dateToday;*/
        }

        $scope.selectedOrganizationAccountVM = {
            aspects: {
                required: true,
                visible: true,
                get validationMessages() {
                    return [$filter('translate')('gateway.views.new-quote.errors.This is a required field')];
                },
                get valid() {
                    return $scope.selectedOrganizationAccountVM.value;
                }
            },
            value: ''
        };

        $scope.producerCodes = [];

        $scope.newAccount = {
            accountHolder: {}
        };
        $scope: {
            address: '=';
        };
        $scope.accountHolder = {
            contactName: '',
            primaryAddress: {
                city: '',
                state: '',
                postalCode: '',
                country: ''
            }

        };

        $scope.availableProducts = function () {
            return $scope._availableProducts;
        };

        $scope.newSubmission = {
            effectiveDate: '', //Adding one date _MSF
            producerCode: '',
            state: '',
            addressLine1: '',
            addressLine2: '',
            addressLine3: '',
            city: '',
            county: '',
            country: '',
            postalCode: '',
            productCode: 'WorkersComp' //Dafaulting the Product Code to Workers comp
        };
        $scope.newSubmission.country = $scope.defaultCountryCode || defaultLocaleDetails.countryCode;
        PolicyService.getCurrentDate().then(function (res) {
            var dateToday = LocalDateUtil.today();
            var today = res.match(/(\d+)/g);
            var nextDay = new Date(today[0], today[1] - 1, parseInt(today[2]) + 1, today[3], today[4], today[5]);
            //nextDay.setDate(today.getDate()+1);
            //console.log("next day-->");console.log(nextDay.getDate());
            dateToday.day = nextDay.getDate();
            dateToday.month = nextDay.getMonth();
            dateToday.year = nextDay.getFullYear();
            $scope.newSubmission.effectiveDate = dateToday;
        });

        //$scope.effectiveDate = angular.copy($scope.effectiveDate);
        //console.log($scope.effectiveDate);
        //$scope.newSubmission.effectiveDate=$scope.effectiveDate.$$state.value;
        console.log($scope.newSubmission.effectiveDate);

        $scope.newSubmissionView = ViewModelService.create($scope.newSubmission, 'pc', 'edge.capabilities.gateway.job.submission.dto.NewSubmissionDTO');
        console.log($scope.newSubmissionView);
        $scope.availableStates = $scope.newSubmissionView.state.aspects.availableValues;
        $scope.newSubmissionView.nonSpecific.value = false;
        console.log($scope.newSubmissionView.nonSpecific);
        $scope.$watch('newSubmissionView.nonSpecific.value', function (nonspecificvalue) {
            console.log(nonspecificvalue);
            $scope.newSubmissionView.nonSpecific.value = nonspecificvalue;
        });

        $scope.refreshingProducts = false;
        $scope.refreshingProducerCodes = false;

        if ($stateParams.accountNumber && $stateParams.accountNumber.length > 0 && $stateParams.accountNumber != "dummy") {
            $scope.accountNumber = $stateParams.accountNumber;
            ctrl.findAccount($scope.accountNumber);
        } else {
            $scope.isAnExistingAccount = false;
            NewAccountService.AccountSearchCriteria = JSON.parse($stateParams.searchResult);

            // Subtype of entity in PolicyCenter is capitalised
            //const criteriaContactType = NewAccountService.AccountSearchCriteria.contactType;
            $scope.contactType = "Company"; //defaulted to company since we are not using the person type_MSF

            if ($scope.contactType === 'Person') {
                $scope.accountHolder.firstName = NewAccountService.AccountSearchCriteria.firstName;
                $scope.accountHolder.lastName = NewAccountService.AccountSearchCriteria.lastName;
                if (NewAccountService.AccountSearchCriteria.lastNameKanji) {
                    $scope.accountHolder.firstNameKanji = NewAccountService.AccountSearchCriteria.firstNameKanji;
                    $scope.accountHolder.lastNameKanji = NewAccountService.AccountSearchCriteria.lastNameKanji;
                }
            } else {
                $scope.accountHolder.contactName = NewAccountService.AccountSearchCriteria.contactName;
                if (NewAccountService.AccountSearchCriteria.contactNameKanji) {
                    $scope.accountHolder.contactNameKanji = NewAccountService.AccountSearchCriteria.contactNameKanji;
                }
            }

            $scope.accountHolder.primaryAddress.city = NewAccountService.AccountSearchCriteria.city;
            if (NewAccountService.AccountSearchCriteria.state) $scope.accountHolder.primaryAddress.state = NewAccountService.AccountSearchCriteria.state;else $scope.accountHolder.primaryAddress.state = $scope.defaultStateCode;
            /*
             * Assigning Primary phone type
             */
            $scope.accountHolder.primaryPhoneType = 'work';
            $scope.accountHolder.primaryAddress.postalCode = NewAccountService.AccountSearchCriteria.postalCode;
            $scope.accountHolder.primaryAddress.country = NewAccountService.AccountSearchCriteria.country;
            if (NewAccountService.AccountSearchCriteria.cityKanji) {
                $scope.accountHolder.primaryAddress.cityKanji = NewAccountService.AccountSearchCriteria.cityKanji;
            }

            $scope.accountHolderView = setAccountHolderView($scope.accountHolder);
            // $scope.copyaccountHolderView=angular.copy($scope.accountHolder.primaryAddress);
            // console.log("statecopy");console.log($scope.accountHolder.primaryAddress.state);
            // $scope.copyaccountHolderView.aspects.required = true;
            // $scope.accountHolderView.primaryAddress.state.aspects=
            /*{
            aspects : {    				
                        required: true,                    
                        get validationMessages() {
                            return ['This is a required field'];
                        },
                        get valid() {
                            return $scope.accountHolderView.primaryAddress.state.value;
                        }
            }                  
                  
                };*/
            /**
             * Phone types
             */
            $scope.phoneTypes = {
                home: _.find($scope.accountHolderView.primaryPhoneType.aspects.availableValues, {
                    code: 'home'
                }),
                work: _.find($scope.accountHolderView.primaryPhoneType.aspects.availableValues, {
                    code: 'work'
                }),
                mobile: _.find($scope.accountHolderView.primaryPhoneType.aspects.availableValues, {
                    code: 'mobile'
                })
            };

            NewAccountService.AccountSearchCriteria.contactName = '';
            NewAccountService.AccountSearchCriteria.lastName = '';
            NewAccountService.AccountSearchCriteria.firstName = '';
            NewAccountService.AccountSearchCriteria.city = '';
            NewAccountService.AccountSearchCriteria.state = '';
            NewAccountService.AccountSearchCriteria.postalCode = '';
        }

        if ($scope.isAgent) {
            getProducerCodes();
        } else {
            var getOrganizationsPromise = OrganizationService.getAvailableOrganizations();

            $scope.allOrganizationsLookup = {
                getMatches: function getMatches(userinput) {
                    var _this = this;

                    return getOrganizationsPromise.then(function (allOrganizations) {
                        return _(allOrganizations).filter(function (organization) {
                            return _this.toString(organization).toLowerCase().includes((userinput || '').toLowerCase());
                        }).take(10).valueOf();
                    }).catch(function () {
                        return ModalService.showError('gateway.views.new-quote.Error retrieving organizations', 'gateway.views.new-quote.Please check for errors and try again');
                    });
                },
                toString: function toString(organization) {
                    return organization.displayName;
                }
            };

            $scope.$watch('selectedOrganizationAccountVM.value', function (organization) {
                if (!organization && $scope.accountHolderView) {
                    $scope.accountHolderView.producerCode = '';
                }
                ctrl.refreshProducerCodes(organization);
            });

            $scope.$watch('selectedOrganizationSubmissionVM.value', function (organization) {
                if (!organization) {
                    $scope.newSubmissionView.producerCode = '';
                    //             $scope.newSubmissionView.productCode = '';     //Product Code already defaulted to Workers Comp
                }
                ctrl.refreshProducerCodes(organization);
            });
        }
    };

    function setAccountHolderView(account) {
        var viewModel = ViewModelService.create(account, 'pc', 'edge.capabilities.policycommon.accountcontact.dto.AccountContactDTO', {
            'ProducerCodeRequired': true
        });
        viewModel.isAgentPortalContact = true;
        if ($scope.contactType === 'Person') {
            viewModel.subtype.value = 'Person';
        } else {
            viewModel.subtype.value = 'Company';
        }
        return viewModel;
    }

    ctrl.refreshProducerCodes = function (organization) {
        if (!organization || $scope.newSubmission.state === undefined || $scope.newSubmission.effectiveDate === null || $scope.newSubmission.effectiveDate === '') {
            $scope.submissionFormNotValid = true;
            return;
        }

        $scope.refreshingProducerCodes = true;
        $scope.submissionFormNotValid = false;

        getProducerCodesForAnOrganization(organization);
    };

    function getProducerCodesForAnOrganization(organization) {
        var producerCodesPromise = OrganizationService.getProducerCodeForOrganization(organization);
        producerCodesPromise.then(function (producerCodesResponse) {
            $scope.producerCodes = producerCodesResponse;
            $scope.refreshingProducerCodes = false;
        }, function () {
            ModalService.showError('gateway.views.modal.Error', 'gateway.views.modal.Error.Data');
        });
    }

    function getProducerCodes() {
        var producerCodesPromise = UserService.getAvailableProducerCodesForCurrentUser();
        producerCodesPromise.then(function (producerCodesResponse) {
            $scope.producerCodes = producerCodesResponse;
        });
    }

    function getAvailableProducts() {
        AccountService.getAvailableProductsForAccount(copyOfNewSubmission()).then(function (availableProductsResponse) {
            $scope._availableProducts = availableProductsResponse;
            //         $scope.newSubmission.productCode = ''; //Product Code already defaulted to Workers Comp
            $scope.refreshingProducts = false;
        }, function () {
            ModalService.showError('gateway.views.modal.Error', 'gateway.views.modal.Error.Data');
        });
    }

    function copyOfNewSubmission() {
        var copyOfSubmission = angular.copy($scope.newSubmission);
        return copyOfSubmission;
    }

    ctrl.setCancelState = function () {
        var title = 'gateway.controllers.NewQuoteCtrl.Cancel Quote';
        var msg = 'gateway.controllers.NewQuoteCtrl.Are you sure you want to cancel the new quote?';
        var description = null;

        var cancelDialogPromise = ModalService.showWarning(title, msg, description, $filter('translate')('gateway.views.modal.Yes'), 'gw-btn-primary', $filter('translate')('gateway.views.modal.No')).result;
        cancelDialogPromise.then(function () {
            var accountNumber = $scope.accountNumber ? $scope.accountNumber : $scope.newAccount.accountNumber;
            if (accountNumber) {
                $state.go('accounts.detail.summary', {
                    accountNumber: accountNumber
                });
            } else if ($scope.isAgent) {
                $state.go('accounts.index');
            } else {
                $state.go('gatewayLanding');
            }
        });
    };

    ctrl.submitCreateAccountForm = function (newAccountForm, accountHolderView) {
        newAccountForm.submitted = true;
        $scope.worksubmitted = true;
        if ($scope.contactType === 'Person') {
            $scope.accountHolder.contactName = $scope.accountHolder.firstName + ' ' + $scope.accountHolder.lastName;
        }
        /*if (newAccountForm.invalid && (newAccountForm.primaryPhoneType.$modelValue.code === 'mobile' || newAccountForm.primaryPhoneType.$modelValue.code === 'work' || newAccountForm.primaryPhoneType.$modelValue.code === 'home')) {
        	//$scope.worksubmitted = false;
            return;
        }*/
        //if(newAccountForm)
        if (accountHolderView.primaryAddress.country.value.code == "US") {
            var regexp = /^[0-9]{5}(?:-[0-9]{4})?$/;
            if (accountHolderView.primaryAddress.postalCode.value != '' && !regexp.test(accountHolderView.primaryAddress.postalCode.value)) {
                $scope.error_exist = true;
                return $scope.error_exist;
            } else {
                $scope.error_exist = false;
            }
        }

        if (accountHolderView.primaryAddress.country.value.code == "MX") {
            var regexp = /^[0-9a-zA-Z]{5}(?:-[0-9a-zA-Z]{4})?$/;
            if (accountHolderView.primaryAddress.postalCode.value != '' && !regexp.test(accountHolderView.primaryAddress.postalCode.value)) {
                $scope.error_exist = true;
                return $scope.error_exist;
            } else {
                $scope.error_exist = false;
            }
        }

        if (accountHolderView.primaryAddress.country.value.code == "CA") {
            var regexp = /^[A-Za-z]\d[A-Za-z][ ]\d[A-Za-z]\d$/;
            if (accountHolderView.primaryAddress.postalCode.value != '' && !regexp.test(accountHolderView.primaryAddress.postalCode.value)) {
                $scope.error_exist = true;
                return $scope.error_exist;
            } else {
                $scope.error_exist = false;
            }
        }

        /*if(accountHolderView.primaryAddress.country.value.code=="AU"){
        	console.log(accountHolderView);
        	var regexp = /^[0-9]{4}$/;
            if (accountHolderView.primaryAddress.postalCode.value!='' && !regexp.test(accountHolderView.primaryAddress.postalCode.value))
              {
                $scope.error_exist = true;
                return $scope.error_exist;
              }
            else
              {
            	$scope.error_exist = false;
              }
        }*/
        if (newAccountForm.$invalid) {
            console.log("Invalid");console.log(newAccountForm.ProducerCode.$modelValue);
            //if(( newAccountForm.primaryPhoneType.$modelValue.code != 'mobile' || newAccountForm.primaryPhoneType.$modelValue.code != 'work' || newAccountForm.primaryPhoneType.$modelValue.code != 'home')){
            if (newAccountForm.WorkNumber.$modelValue == undefined || newAccountForm.CellNumber.$modelValue == undefined) {
                console.log($scope.worksubmitted);
                $scope.worksubmitted = false;
                return $scope.worksubmitted;
            } else {
                newAccountForm.submitted = true;
                return newAccountForm.submitted;
            }
        }
        console.log("calling create account-->");
        this.createNewAccount();
    };

    ctrl.submitNewSubmissionForm = function (newSubmissionForm, newSubmissionView) {
        console.log("Before start submission");
        console.log(newSubmissionView);
        console.log(newSubmissionForm);
        newSubmissionForm.submitted = true;
        if (newSubmissionForm.invalid) {
            return;
        }
        //if(newSubmissionView.primaryAddress.country.value.code!="CA"){
        var regexp = /^[0-9]{5}(?:-[0-9]{4})?$/;
        if (newSubmissionView.postalCode.value != '' && !regexp.test(newSubmissionView.postalCode.value)) {
            $scope.error_exist = true;
            return $scope.error_exist;
        } else {
            $scope.error_exist = false;
        }
        // }
        this.startSubmission();
    };

    ctrl.defineWatches = function () {
        //$scope.$watch('newSubmission.producerCode', ctrl.refreshProducts); //commented for Effective Date validation_MSF

        $scope.$watch('newSubmission.state', ctrl.refreshProducts);

        // $scope.$watch('newSubmission.effectiveDate', ctrl.refreshProducts); //commented for Effective Date validation_MSF
    };

    ctrl.refreshProducts = function () {
        var isEmpty = function isEmpty(value) {
            return !value;
        };

        if (isEmpty($scope.newSubmission.producerCode) || isEmpty($scope.newSubmission.state) || isEmpty($scope.newSubmission.effectiveDate)) {
            $scope.submissionFormNotValid = true;
            return;
        }

        $scope.refreshingProducts = true;
        $scope.submissionFormNotValid = false;

        getAvailableProducts();
    };

    ctrl.findAccount = function (accountNumber) {
        if (angular.isDefined(accountNumber) && accountNumber.length > 0) {
            var findAccountPromise = AccountService.getAccountDetails(accountNumber);
            $scope.findAccountPromise = findAccountPromise;

            $q.when(findAccountPromise, function (account) {
                if (account.accountHolder) {
                    $scope.contactType = account.accountHolder.subtype;
                    $scope.newAccount = account;
                    $scope.newSubmission.state = account.accountHolder.primaryAddress.state;
                    $scope.displayAddressArray = account.accountHolder.primaryAddress.displayName.split(', ');
                    $scope.newSubmission.accountNumber = account.accountNumber;
                    $scope.isAnExistingAccount = true;
                } else {
                    ModalService.showError('gateway.views.modal.Error', 'gateway.views.new-quote.error.findAccount.account.type');
                    history.back();
                }

                $scope.accountHolderView = setAccountHolderView($scope.newAccount);
            }, function () {
                var msg = $translate('gateway.views.new-quote.error.findAccount.noaccount', {
                    accountNumber: accountNumber
                });
                ModalService.showError('gateway.views.modal.Error', msg);
                $state.go('newQuoteSearch');
            });
        }
    };

    ctrl.changeContactType = function (type) {
        $scope.contactType = type;
        $scope.accountHolderView = setAccountHolderView($scope.accountHolder);
    };

    ctrl.createNewAccount = function () {
        var newAccount = {};

        var home = angular.element('#HomeNumber').val();
        var work = angular.element('#WorkNumber').val();

        if (home != undefined && home != null && home.trim() != '') {
            $scope.accountHolder.homeNumberExtension = home.split('x')[1].trim().replace(/\D/g, '');
            $scope.accountHolder.homeNumber = home.split('x')[0].trim().replace(/\D/g, '');
        }
        if (work != undefined && work != null && work.trim() != '') {
            $scope.accountHolder.workNumberExtension = work.split('x')[1].trim().replace(/\D/g, '');
            $scope.accountHolder.workNumber = work.split('x')[0].trim().replace(/\D/g, '');
        }

        if ($scope.contactType === 'Person') {
            $scope.accountHolder.primaryAddress.addressType = 'home';
            newAccount.accountHolder = $scope.accountHolder;
        } else {
            $scope.accountHolder.primaryAddress.addressType = 'business';
            //$scope.accountHolder.primaryAddress.state = 'business';
            newAccount.accountHolder = $scope.accountHolder;
        }
        newAccount.producerCodes = [{
            code: $scope.accountHolder.producerCode
        }];
        //Remove entity type when empty value selected
        if (newAccount.accountHolder.mSFEntityType_EXT === undefined) delete newAccount.accountHolder.mSFEntityType_EXT;
        if (newAccount.accountHolder.primaryAddress.state == '') delete newAccount.accountHolder.primaryAddress.state;
        console.log(newAccount);
        var newAccountPromise = AccountService.getOrCreateAccount(newAccount);
        $scope.newAccountPromise = newAccountPromise;

        $q.when(newAccountPromise, function (newAccountResponse) {
            if (newAccountResponse.accountNumber > 0) {
                $scope.newAccount = newAccountResponse;
                $scope.newSubmission.state = newAccountResponse.accountHolder.primaryAddress.State;
                $scope.displayAddressArray = newAccountResponse.accountHolder.primaryAddress.displayName.split(', ');
                $scope.newSubmission.accountNumber = newAccountResponse.accountNumber;
                $scope.isAnExistingAccount = true;
            }
            //Redirection
            newAccountPromise.then(function (data) {
                var state = $state.get('newQuote');
                $state.transitionTo(state, { accountNumber: data.accountNumber });
            });
        }, function () {
            ModalService.showError('gateway.views.modal.Error', 'gateway.views.new-quote.error.create.account');
        });
    };

    $scope.is_usZipCode = function (value) {
        if (value == '' || value == undefined) {
            $scope.error_exist = false;
        } else {
            //scope.error_exist = true;
            var regexp = /^[0-9]{5}(?:-[0-9]{4})?$/;
            if (value != '' && !regexp.test(value)) {
                $scope.error_exist = true;
            } else {
                $scope.error_exist = false;
            }
        }
    };

    $scope.is_mxZipCode = function (value) {
        if (value == '' || value == undefined) {
            $scope.error_exist = false;
        } else {
            //scope.error_exist = true;
            var regexp = /^[0-9a-zA-Z]{5}(?:-[0-9a-zA-Z]{4})?$/;
            if (value != '' && !regexp.test(value)) {
                $scope.error_exist = true;
            } else {
                $scope.error_exist = false;
            }
        }
    };

    $scope.$watch('newSubmissionView.postalCode.value', function (value) {
        //if($scope.newSubmissionView.country.value.code == 'US' && $scope.address.postalCode.value!=undefined)
        $scope.is_usZipCode(value);
    });

    ctrl.startSubmission = function () {
        if ($scope.isAnExistingAccount) {
            doSubmission($scope.accountNumber);
        }

        function doSubmission() /* accountNumber*/{
            var newSubmission = copyOfNewSubmission();
            console.log("test");console.log(newSubmission);
            newSubmission.accountNumber = $scope.newAccount.accountNumber;
            newSubmission.state = 'MT';
            console.log("newsubmission screen");console.log(newSubmission);
            var newSubmissionPromise = SubmissionService.createSubmission(newSubmission);
            $scope.newSubmissionPromise = newSubmissionPromise;

            $q.when(newSubmissionPromise, function (newSubmissionResponse) {
                console.log("newSubmissionResponse");
                if (newSubmissionResponse.jobNumber > 0) {
                    if ($scope.gatewayQuote && _.contains(lobConfig.lobs, lobMap[$scope.newSubmission.productCode])) {

                        var postalCode = newSubmissionResponse.policy.account.accountHolder.primaryAddress.postalCode ? newSubmissionResponse.policy.account.accountHolder.primaryAddress.postalCode : $scope.newAccount.accountHolder.primaryAddress.postalCode;
                        $state.transitionTo('quoteentry', {
                            postalCode: postalCode,
                            quoteID: newSubmissionResponse.jobNumber,
                            gatewayportalnewsubmission: true
                        });
                    } else {
                        // Redirect to PolicyCenter EntryPoint to continue new submission
                        $window.location.href = GPA_PC_ENTRY_POINT + '?JobNumber=' + newSubmissionResponse.jobNumber;
                    }
                }
            }, function () {
                ModalService.showError('gateway.views.modal.Error', 'gateway.views.new-quote.error.create.submission');
            });
        }
    };

    return ctrl.create($scope);
};

fn.$inject = ['$translate', '$q', '$filter', 'lobConfig', '$scope', '$state', '$stateParams', '$window', 'ModalService', 'AccountService', 'SubmissionService', 'ProductService', 'UserService', 'OrganizationService', 'NewAccountService', 'defaultLocaleDetails', 'ViewModelService', 'UserInfoService', 'GPA_PC_ENTRY_POINT', 'LocaleService', 'policy.PolicyService'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/controllers/NewQuoteCtrl.js
// module id = 1677
// module chunks = 0